module.exports = __webpack_public_path__ + "img/banner.9e77891b.png";